import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { WatchlistCell } from '../WatchlistCell';

export class MaterialSensorRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr={'Produktbild'}/></td>
            <AttributeCell product={product} attr="@parent.Messrate"/>
            <AttributeCell product={product} attr="@parent.Ausgangssignal"/>
            <AttributeCell product={product} attr="@parent.Eignungsliste_fuer_Materialien" extra={true}/>
            <AttributeCell product={product} attr="@parent.Erfassungsbreite" extra={true}/>
            <AttributeCell product={product} attr="Gabelbreite" extra={true}/>
            <AttributeCell product={product} attr="@parent.Aufloesung" extra={true}/>
            <td>&nbsp;</td>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={3} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }
}
